import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import '../index.css';
import { fetchWithAuth } from "../auth"

function gf_order(data) {
  data.sort(function (a, b) {
    if (a.house < b.house) {
      return -1;
    }
    if (a.house > b.house) {
      return 1;
    }
    return 0;
  })
  return data
}

function gf_timestamp(stringtime) {
  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);
  if (isNumeric(stringtime)) {
    let unix_timestamp = stringtime;
    var a = new Date(unix_timestamp * 1000);
    
    // var year = a.getFullYear();
    // var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    // var month = months[a.getMonth()];
    var month = ("0" + (a.getMonth() + 1)).slice(-2); 
    var day = ("0" + a.getDate()).slice(-2);
    var hour = ("0" + a.getHours()).slice(-2);
    var min = ("0" + a.getMinutes()).slice(-2);

    // var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
    var time = hour + ':' + min + "  " + day + "/" + month;
    return time;
  } else {
    return stringtime;
  }
}

function isAliveBehindMin(tsSec, minutes = 2) {
  const nowMs = Date.now();                // current time in ms
  const tsMs = Number(tsSec) * 1000;       // convert seconds → ms
  return (nowMs - tsMs) > minutes * 60_000;
}

function gf_isAliveBehind(tsSec) {
  return isAliveBehindMin(tsSec, 2) 
    ? isAliveBehindMin(tsSec, 60) 
      ? 'red'
      : '#fef3c7' 
    : '';
}

function gf_latest_version(version) {
  // return (version === "1_9") ? '' : '#fef3c7';
  // to check the latest firmware version released: to insert it as ENV Variable of Frontend or api response from backend?
  return '';
}

function gf_version(version) {
  if (typeof version !== 'string') return version;
  const parts = version.split('_');
  if (parts.length !== 3) {
    return version;
  }
  const [major, minor, patch] = version.split('_');
  if (!/^\d+$/.test(patch)) { // ensure patch is a number
    return version;
  }
  if (patch === '0') {
    return `${major}_${minor}`;
  }
  return version;
}

function gf_battery_lowlevel(value) {
  if((value === null) || (value === '')) {
    return 'orange';
  }
  if(value <= 20) {
    return 'red';
  }
  return '';
}

function gf_battery(value) {
  if((value === null) || (value === '')) {
    return "NO";
  }
  return value;
}

const Home = () => {
  const [gatewaysState, setGatewaysState] = useState([]);

  useEffect(() => {
    f_aggiorna();
    const interval=setInterval(()=>{f_aggiorna()}, 10000);
     return()=>clearInterval(interval)
  }, []);

  function f_aggiorna() {
    fetchWithAuth('/gateways', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(data => {
        data = gf_order(data)
        setGatewaysState(data)
      })
  }

  function f_entra(device) {
    navigate(`/device/${device.serial}`, {
      state: {
        location: device.location,
        house: device.house
      }
    })
  }

  const API_URL = process.env.REACT_APP_API_URL || "/api";
  function f_riavvia(device) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ serial: device.serial })
    };
    fetch(API_URL + '/cmdrebootapp', requestOptions);
  }

  const [visibleColumns, setVisibleColumns] = useState({
    seriale: true,
    luogo: true,
    ambiente: true,
    start: true, // start
    numStart: true, // start
    alive: true,
    sw: true,
    numAa: true, // device
    pb: true, // device
    ws: false, // extra_device
    sa: false, // extra_device
    wl: false, // extra_device
  });

  const [userVisualization, setUserVisualization] = useState({
    start: true,
    device: true,
    extra_device: false,
  });

   const handleUserVisualization = (key) => {
    const newValue = !userVisualization[key];
    setUserVisualization((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
    if (key === "start") {
      setVisibleColumns((prev) => ({
        ...prev,
        ['start']: newValue,
        ['numStart']: newValue,
      }));
    }
    if (key === "device") {
      setVisibleColumns((prev) => ({
        ...prev,
        ['numAa']: newValue,
        ['pb']: newValue,
      }));
    }
    if (key === "extra_device") {
      setVisibleColumns((prev) => ({
        ...prev,
        ['ws']: newValue,
        ['sa']: newValue,
        ['wl']: newValue,
      }));
    }
  };

  const [selectedLocation, setSelectedLocation] = useState("");
  const uniqueLocations = [...new Set(gatewaysState.map(g => g.location))];
  const filteredGateways = gatewaysState.filter(
    gw => !selectedLocation || gw.location === selectedLocation
  );
  const navigate = useNavigate();

  return (

    <div>
      <h1>Home</h1>
      <a href="/sensors">
        <button>Sensori</button>
      </a>
      <br /><br />
      <button onClick={() => navigate(`/be_log`, {
        state: {
          location: null,
          house: null
        }
      })}>
        BE Log
      </button>
      <br /><br />
      <button onClick={f_aggiorna}>aggiorna</button>
      <br /><br />
      Luogo:{" "}
      <select
        value={selectedLocation}
        onChange={(e) => setSelectedLocation(e.target.value)}
      >
        <option value="">Tutti</option>
        {uniqueLocations.map((location) => (
          <option key={location} value={location}>
            {location}
          </option>
        ))}
      </select>
      <br /><br />
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        alignItems: "center",
        marginBottom: "10px"
      }}>
        {Object.keys(userVisualization).map((key) => (
          <label key={key} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <input
              type="checkbox"
              checked={userVisualization[key]}
              onChange={() => handleUserVisualization(key)}
            />
            {key}
          </label>
        ))}
      </div>
      <br />

      <table>
        <tbody>
          <tr>
            {visibleColumns.seriale && <th className="title">Seriale</th>}
            {visibleColumns.luogo && <th className="title">Luogo</th>}
            {visibleColumns.ambiente && <th className="title">Ambiente</th>}
            {visibleColumns.start && <th className="title">start</th>}
            {visibleColumns.numStart && <th className="title"># start</th>}
            {visibleColumns.alive && <th className="title">alive</th>}
            {visibleColumns.sw && <th className="title">SW</th>}
            {visibleColumns.numAa && <th className="title"># aa</th>}
            {visibleColumns.pb && <th className="title">pb %</th>}
            {visibleColumns.ws && <th className="title">ws %</th>}
            {visibleColumns.sa && <th className="title">sa %</th>}
            {visibleColumns.wl && <th className="title">wl %</th>}
            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
          </tr>
          {filteredGateways.map(mapGW => (
            <tr key={mapGW.serial}>
              {visibleColumns.seriale && <td>{mapGW.serial}</td>}
              {visibleColumns.luogo && <td>{mapGW.location}</td>}
              {visibleColumns.ambiente && <td>{mapGW.house}</td>}
              {visibleColumns.start && <td>{gf_timestamp(mapGW.time)}</td>}
              {visibleColumns.numStart && <td>{mapGW.executions}</td>}
              {visibleColumns.alive && <td style={{ backgroundColor: gf_isAliveBehind(mapGW.alive) }}>{gf_timestamp(mapGW.alive)}</td>}
              {visibleColumns.sw && <td style={{ backgroundColor: gf_latest_version(mapGW.version) }}>{gf_version(mapGW.version)}</td>}
              {visibleColumns.numAa && <td>{mapGW.aa}</td>}
              {visibleColumns.pb && <td style={{ backgroundColor: gf_battery_lowlevel(mapGW.pb) }}>{gf_battery(mapGW.pb)}</td>}
              {visibleColumns.ws && <td>{gf_battery(mapGW.ws)}</td>}
              {visibleColumns.sa && <td>{gf_battery(mapGW.sa)}</td>}
              {visibleColumns.wl && <td>{gf_battery(mapGW.wl)}</td>}
              <td style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}>
                <button onClick={() => f_entra(mapGW)}>entra</button>
              </td>
              <td style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}>
                <button onClick={() => f_riavvia(mapGW)}>riavvia</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
};

export default Home;
